export default "__VITE_ASSET__CwYSQEJz__"